module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp13_8023.105eef73.png";